import { downloadFileApi, fetchApi } from "infrastructure/api";
import { HttpVerb } from "consts/api";
import { ApiRoutes } from "consts/enpoints/api";
import { OnboardingApplicationStepAndFieldStatus } from "consts/onboarding";
import type {
    Application,
    OnboardingBankingAndFinance,
    OnboardingBusinessInformation,
    OnboardingMediaAndComplianceCheck,
    OnboardingPaymentMethod,
    UboIdentity,
    WithFieldsComments,
    WithFieldsStatuses,
    WithRequestedChangeFileds,
    WithStatus,
    WithUser,
    WithRejectReson
} from "./types";
import type { Entity } from "types";

export const getApplications = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetApplications()}${queryString}`);

export const putApplication = ({ userId, ...body }: WithUser & Partial<WithRejectReson<Application>>) =>
    fetchApi(ApiRoutes.PutApplications(userId), {
        method: HttpVerb.Put,
        body
    });

export const sendDecision = ({ userId }: WithUser) =>
    fetchApi(ApiRoutes.PatchApplications(userId), {
        method: HttpVerb.Patch,
        headers: {
            Action: 'sendDecision'
        }
    });

export const deleteApplication = ({ userId }: WithUser) =>
    fetchApi(ApiRoutes.DeleteApplications(userId), {
        method: HttpVerb.Delete
    });

export const getECommerceBusinessInformationSteps = ({ userId }: WithUser) =>
    fetchApi(ApiRoutes.GetECommerceBusinessInformationSteps(userId));

export const putECommerceBusinessInformationSteps = (body: WithUser & Partial<OnboardingBusinessInformation>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutECommerceBusinessInformationSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const getECommerceBillingFinanceSteps = ({ userId }: WithUser) =>
    fetchApi(ApiRoutes.GetECommerceBillingFinanceSteps(userId));

export const putECommerceBillingFinanceSteps = (body: WithUser & Partial<OnboardingBankingAndFinance>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutECommerceBillingFinanceSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const getECommerceMediaComplianceSteps = ({ userId }: WithUser) =>
    fetchApi(ApiRoutes.GetECommerceMediaComplianceSteps(userId));

export const putECommerceMediaComplianceSteps = (body: WithUser & Partial<OnboardingMediaAndComplianceCheck>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutECommerceMediaComplianceSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const getECommerceIdentityVerificationSteps = ({ userId }: WithUser) =>
    fetchApi(ApiRoutes.GetECommerceIdentityVerificationSteps(userId));

export const putECommerceIdentityVerificationSteps = (body:
    & WithUser
    & WithStatus<OnboardingApplicationStepAndFieldStatus>
    & WithRequestedChangeFileds
    & WithFieldsStatuses
    & WithFieldsComments
) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutECommerceIdentityVerificationSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const putECommerceUboIdentities = (body: Entity & Partial<UboIdentity>) => {
    const { pki } = body;

    return fetchApi(ApiRoutes.PutECommerceUboIdentities(pki), {
        method: HttpVerb.Put,
        body
    });
};

export const getECommercePaymentMethodsSteps = ({ userId }: WithUser) =>
    fetchApi(ApiRoutes.GetECommercePaymentMethodsSteps(userId));

export const putECommercePaymentMethodsSteps = (body: WithUser & Partial<OnboardingPaymentMethod>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutECommercePaymentMethodsSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const downloadOnboardingApplication = ({ userId }: WithUser) => (
    downloadFileApi(ApiRoutes.GetApplications(userId), {
        headers: {
            Accept: 'application/zip',
        },
        fileName: `application_${userId}.zip`,
    })
);

